/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@ngx-translate/core/src/translate.pipe';
import * as i2 from '@ngx-translate/core/src/translate.service';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../../src/app/modules/algolia/algolia-search/algolia-search.component';
import * as i5 from '@angular/forms';
import * as i6 from '../../../../../../src/app/modules/algolia/algolia.service';
import * as i7 from '../../../../../../src/app/mixpanel/mixpanel.service';
var styles_AlgoliaSearchComponent = [];
export var RenderType_AlgoliaSearchComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_AlgoliaSearchComponent, data: {} });
function View_AlgoliaSearchComponent_2(_l) {
    return i0.ɵvid(0, [i0.ɵncd(null, 0), (_l()(), i0.ɵand(0, null, null, 0))], null, null);
}
function View_AlgoliaSearchComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵand(0, null, null, 0))], null, null);
}
function View_AlgoliaSearchComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 2, 'label', [['class',
                'algolia-label']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['', ' ', ''])), i0.ɵpid(131072, i1.TranslatePipe, [i2.TranslateService, i0.ChangeDetectorRef])], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.nbrResults;
        var currVal_1 = i0.ɵunv(_v, 1, 1, i0.ɵnov(_v, 2).transform('ORDER.FORM.PARTS.RESULTS'));
        _ck(_v, 1, 0, currVal_0, currVal_1);
    });
}
function View_AlgoliaSearchComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.loadPage(0) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['<<']))], null, null);
}
function View_AlgoliaSearchComponent_7(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.loadPage((_co.params.page - 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, [' <']))], null, null);
}
function View_AlgoliaSearchComponent_9(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.loadPage(_v.parent.context.$implicit) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', '']))], null, function (_ck, _v) {
        var currVal_0 = (_v.parent.context.$implicit + 1);
        _ck(_v, 1, 0, currVal_0);
    });
}
function View_AlgoliaSearchComponent_8(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'page']], null, null, null, null, null)),
        i0.ɵdid(278528, null, 0, i3.NgClass, [i0.IterableDiffers, i0.KeyValueDiffers,
            i0.ElementRef, i0.Renderer], { klass: [0, 'klass'], ngClass: [1, 'ngClass'] }, null),
        i0.ɵpod({ active: 0 }), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_9)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = 'page';
        var currVal_1 = _ck(_v, 2, 0, (_co.params.page == _v.context.$implicit));
        _ck(_v, 1, 0, currVal_0, currVal_1);
        var currVal_2 = (_v.context.$implicit < (_co.getMaxPage() + 1));
        _ck(_v, 5, 0, currVal_2);
    }, null);
}
function View_AlgoliaSearchComponent_10(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.loadPage((_co.params.page + 1)) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['> ']))], null, null);
}
function View_AlgoliaSearchComponent_11(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'span', [], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.loadPage(_co.getMaxPage()) !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['>>']))], null, null);
}
function View_AlgoliaSearchComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 28, 'div', [['class',
                'pager']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'page']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_6)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'page']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(),
            i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_7)),
        i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(),
            i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_8)), i0.ɵdid(802816, null, 0, i3.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'page']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_10)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'page']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n          '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_11)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n        \n      ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.params.page;
        _ck(_v, 5, 0, currVal_0);
        var currVal_1 = _co.params.page;
        _ck(_v, 11, 0, currVal_1);
        var currVal_2 = _co.pages;
        _ck(_v, 15, 0, currVal_2);
        var currVal_3 = (_co.params.page < _co.getMaxPage());
        _ck(_v, 20, 0, currVal_3);
        var currVal_4 = (_co.params.page < _co.getMaxPage());
        _ck(_v, 26, 0, currVal_4);
    }, null);
}
function View_AlgoliaSearchComponent_12(_l) {
    return i0.ɵvid(0, [i0.ɵncd(null, 1), (_l()(), i0.ɵand(0, null, null, 0))], null, null);
}
function View_AlgoliaSearchComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 33, 'div', [['class',
                'algolia-results row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])),
        (_l()(), i0.ɵand(16777216, null, null, 2, null, View_AlgoliaSearchComponent_2)),
        i0.ɵdid(540672, null, 0, i3.NgTemplateOutlet, [i0.ViewContainerRef], { ngTemplateOutletContext: [0,
                'ngTemplateOutletContext'], ngTemplateOutlet: [1, 'ngTemplateOutlet'] }, null),
        i0.ɵpod({ nbrResults: 0 }), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-xs-12'], ['style', 'margin-bottom:10px;']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_3)), i0.ɵdid(802816, null, 0, i3.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'],
            ngForTemplate: [1, 'ngForTemplate'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_4)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-xs-12 col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_5)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class', 'col-xs-12']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵand(16777216, null, null, 2, null, View_AlgoliaSearchComponent_12)), i0.ɵdid(540672, null, 0, i3.NgTemplateOutlet, [i0.ViewContainerRef], { ngTemplateOutletContext: [0, 'ngTemplateOutletContext'],
            ngTemplateOutlet: [1, 'ngTemplateOutlet'] }, null), i0.ɵpod({ searchString: 0,
            nbrResults: 1 }), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n  ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _ck(_v, 6, 0, _co.nbrResults);
        var currVal_1 = _co.algoliaHeader;
        _ck(_v, 5, 0, currVal_0, currVal_1);
        var currVal_2 = _co.results;
        var currVal_3 = _co.itemTemplate;
        _ck(_v, 12, 0, currVal_2, currVal_3);
        var currVal_4 = (((_co.searchString != '') && _co.results) && (_co.nbrResults > 0));
        _ck(_v, 18, 0, currVal_4);
        var currVal_5 = ((_co.nbrResults - _co.params.hitsPerPage) > 0);
        _ck(_v, 24, 0, currVal_5);
        var currVal_6 = _ck(_v, 31, 0, _co.searchString, _co.nbrResults);
        var currVal_7 = _co.algoliaFooter;
        _ck(_v, 30, 0, currVal_6, currVal_7);
    }, null);
}
export function View_AlgoliaSearchComponent_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class',
                'algolia-container']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(),
            i0.ɵeld(0, null, null, 8, 'div', [['class', 'col-xs-12 col-sm-6']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n      '])), (_l()(), i0.ɵeld(0, null, null, 5, 'input', [['autocomplete', 'off'], ['type', 'text']], [[2, 'ng-untouched',
                null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
            [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                null], [2, 'ng-pending', null]], [[null, 'keydown'],
            [null, 'keyup'], [null, 'ngModelChange'], [null,
                'input'], [null, 'blur'], [null, 'compositionstart'],
            [null, 'compositionend']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('input' === en)) {
                var pd_0 = (i0.ɵnov(_v, 7)._handleInput($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 7).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
                var pd_2 = (i0.ɵnov(_v, 7)._compositionStart() !== false);
                ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
                var pd_3 = (i0.ɵnov(_v, 7)._compositionEnd($event.target.value) !== false);
                ad = (pd_3 && ad);
            }
            if (('keydown' === en)) {
                var pd_4 = (_co.navigate($event) !== false);
                ad = (pd_4 && ad);
            }
            if (('keyup' === en)) {
                var pd_5 = (_co.search($event) !== false);
                ad = (pd_5 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_6 = ((_co.searchString = $event) !== false);
                ad = (pd_6 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i5.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i5.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i5.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i5.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i5.NgModel, [[8, null],
            [8, null], [8, null], [2, i5.NG_VALUE_ACCESSOR]], { model: [0,
                'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i5.NgControl, null, [i5.NgModel]), i0.ɵdid(16384, null, 0, i5.NgControlStatus, [i5.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵted(null, ['\n  '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_AlgoliaSearchComponent_1)), i0.ɵdid(16384, null, 0, i3.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.searchString;
        _ck(_v, 9, 0, currVal_7);
        var currVal_8 = (_co.searchString != '');
        _ck(_v, 16, 0, currVal_8);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 11).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 11).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 11).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 11).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 11).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 11).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 11).ngClassPending;
        _ck(_v, 6, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
    });
}
export function View_AlgoliaSearchComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'pt-algolia-search', [], null, null, null, View_AlgoliaSearchComponent_0, RenderType_AlgoliaSearchComponent)), i0.ɵdid(245760, null, 3, i4.AlgoliaSearchComponent, [i6.AlgoliaService, i7.MixpanelService], null, null), i0.ɵqud(335544320, 1, { itemTemplate: 0 }), i0.ɵqud(335544320, 2, { algoliaFooter: 0 }), i0.ɵqud(335544320, 3, { algoliaHeader: 0 })], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var AlgoliaSearchComponentNgFactory = i0.ɵccf('pt-algolia-search', i4.AlgoliaSearchComponent, View_AlgoliaSearchComponent_Host_0, { index: 'index', params: 'params' }, { onKeyEnter: 'onKeyEnter' }, ['*', '*']);
//# sourceMappingURL=algolia-search.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./aot/src/app/modules/algolia/algolia-search/algolia-search.component.ngfactory.js
// module id = 1191
// module chunks = 0